import { useContext } from 'react'

import Context from './context'

export function useToken () {
  const { token, setToken } = useContext(Context)

  return { token, setToken }
}
